import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {ANALYTICS} from "../../../third-party-services/analytics/analytics-consts";

export class TabClickEvent extends ClickEvent {
  tab: String;
  entityType: ANALYTICS.ENTITY_TYPES;
  entityId: Number;

  // not implemented yet
  clickType: ANALYTICS.CLICK_TYPES;

  constructor(params: TabClickEvent) {
    super('', 'click', 'tab');

    this.tab = params.tab;
    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.clickType = params.clickType;
  }

  get properties() {
    const properties = super.properties;

    properties.clickType = this.clickType;
    properties.entityType = this.entityType;
    properties.entityId = this.entityId;
    properties.tab = this.tab;

    return properties;
  }

}
